import React, { useEffect, useState } from 'react'
import styles from './index.module.scss'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import PrimaryButton from '../button';
import RegistrationModal from '../registration-modal';
import axios from 'axios';

const API_KEY = process.env.REACT_APP_MAILER_LITE_API_KEY;
const API_URL = "https://connect.mailerlite.com/api/subscribers";

const corouselContent = [
    {
        id: 1,
        class: styles.bgImg1
    },
    {
        id: 2,
        class: styles.bgImg2
    },
    {
        id: 3,
        class: styles.bgImg3
    },
    {
        id: 4,
        class: styles.bgImg4
    }
]


const RegistrationSection = () => {
    const [attendee, setAttendee] =  useState({firstname: "", lastname: "", mobile: "", email: "", gender: "", category: "", institution:"", dept:"", maritalStatus: "", membershipStatus: "", modeOfAttendance: "Physical"})
    const [loading, setLoading] = useState(false);
    const [openRegistrationModal, setOpenRegistrationModal] = useState(false);  
    const [modalType, setModalType] = useState('success');
    const [isRegistrationClosed, setIsRegistrationClosed] = useState(true);

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        console.log(attendee);
        setAttendee({
            ...attendee, 
            dateRegistered: new Date().toLocaleDateString("en-GB", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                }
            ), 
            [name]:value
        })
    }

    // const getRegisteredAttendees = () => {
    //     axios.get('https://sheetdb.io/api/v1/vtc67suhivwxo')
    //     .then(function (response) {
    //         const attendees = response.data;
    //         console.log(attendees)
    //     })
    //     .catch(function (error) {
    //         console.log(error);
    //     });
    // }

    const sendWelcomeEmail = async () => {
        try{
            const response = await axios.post(API_URL, {
                email: attendee.email,
                fields:{
                    name: attendee.firstname,
                    last_name: attendee.lastname, 
                    phone: attendee.mobile,
                }, 
                groups:["180669414473992147"]
            }, {
                headers:{
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${API_KEY}`
                }
            })
            console.log(response)
            return response.data
        } catch(error){
            console.log(error)
            throw error
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        if(isRegistrationClosed){
            setOpenRegistrationModal(true)
            setModalType('info')
            return
        }
        setLoading(true)
        axios.post('https://sheetdb.io/api/v1/dpi3igbm8fss3', attendee, {
            headers:{
                "Content-Type": "application/json",
            }
        })
        .then(function (response) {
            console.log(response)
            setLoading(false)
            sendWelcomeEmail(attendee)
            setOpenRegistrationModal(true)
            setModalType('success')
            setAttendee({firstname: "", lastname: "", mobile: "", email: "", gender: "", category: "", institution:"", dept:"",  maritalStatus: "", membershipStatus: "", chapter: "", modeOfAttendance: "", invitedBy: ""})
        })
        .catch(function (error) {
            console.log(error);
            setLoading(false)
            setOpenRegistrationModal(true)
            setModalType('error')
        });
    }

    // useEffect(() => {
    //     getRegisteredAttendees()
    // }, [])

    return (
        <section className={styles.registration_section} id="registration">
            <div className={styles.registration_header}>
                <h2>Registration</h2>
                <p>Want to join us for a life-giving experience? Register here</p>
            </div>
            <div className={styles.registration_container}>
                <div className={styles.registration_inner}>
                    <Carousel 
                        showThumbs={false} 
                        autoPlay={true} 
                        interval={4000} 
                        transitionTime={1500}
                        infiniteLoop={true}
                        showArrows={false}
                        showIndicators={false}
                        showStatus={false}
                        stopOnHover={false}
                        swipeable={false}
                        animationHandler='fade'
                    >
                        {
                            corouselContent.map((content) => (
                                <div key={content.id} className={`${styles.reg_carousel_container} ${content.class}`}>
                                    <div className={styles.reg_carousel_content}>
                                        <h3>“And I heard the voice of the Lord saying, 'Whom shall I send, and who will go for us?' Then I said, 'Here I am! Send me.” <br /> - Isaiah 6:8 </h3>
                                    </div>
                                </div>
                            ))
                        }
                    </Carousel>
                    <div className={styles.registration_form}>  
                        <form onSubmit={handleSubmit}>
                            <div className={styles.form_name}>
                                <div className={styles.input_item}>
                                    <label>First Name <span className={styles.required_input}>*</span> </label> <br />
                                    <input 
                                        type="text" 
                                        name="firstname" 
                                        placeholder="John"  
                                        className={styles.input}
                                        value={attendee.firstname}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className={styles.input_item}>
                                    <label>Last Name <span className={styles.required_input}>*</span></label> <br />
                                    <input 
                                        type="text" 
                                        name="lastname" 
                                        placeholder="Doe" 
                                        className={styles.input}
                                        value={attendee.lastname}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>
                            <div className={styles.form_input}>
                                <label>Phone Number <span className={styles.required_input}>*</span></label> <br />
                                <input 
                                    type="number" 
                                    name="mobile" 
                                    placeholder="080XXX" 
                                    className={styles.input}
                                    value={attendee.mobile}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className={styles.form_input}>
                                <label>Email Address <span className={styles.required_input}>*</span></label> <br />
                                <input 
                                    type="email" 
                                    name="email" 
                                    placeholder="example@email.com" 
                                    className={styles.input}
                                    value={attendee.email}
                                    onChange={handleChange}
                                    required
                                />                            
                            </div>
                            <div className={styles.option_item}>
                                <label>Gender <span className={styles.required_input}>*</span></label> <br />
                                <select name="gender"  id="gender" className={styles.select} value={attendee.gender} onChange={handleChange} required>
                                    <option value="">--Select your gender--</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                </select>        
                            </div>
                            <div className={styles.option_item}>
                                <label>Category <span className={styles.required_input}>*</span></label> <br />
                                <select name="category"  id="category" className={styles.select} value={attendee.category} onChange={handleChange} required>
                                    <option value="">--Select your category--</option>
                                    <option value="student">Student</option>
                                    <option value="graduate">Recent Graduate</option>
                                    <option value="worker">Worker</option>
                                    <option value="children">Children</option>
                                    {/* <option value="others">Others</option> */}
                                </select>        
                            </div>
                            {
                                attendee.category=== "student" &&
                                <div>
                                    <div className={styles.form_input}>
                                        <label>Institution/School <span className={styles.required_input}>*</span></label> <br />
                                        <input 
                                            type="text" 
                                            name="institution" 
                                            className={styles.input}
                                            value={attendee.institution}
                                            onChange={handleChange}
                                            required={attendee.category === 'student'}
                                        />                            
                                    </div> 
                                    <div className={styles.form_input}>
                                        <label>Department</label> <br />
                                        <input 
                                            type="text" 
                                            name="dept" 
                                            className={styles.input}
                                            value={attendee.dept}
                                            onChange={handleChange}
                                        />                            
                                    </div>
                                    {/* <div className={styles.form_input}>
                                        <label>Hostel (optional)</label> <br />
                                        <input 
                                            type="text" 
                                            name="hostel" 
                                            className={styles.input}
                                            value={attendee.hostel}
                                            onChange={handleChange}
                                        />                            
                                    </div>   */}
                                </div>
                            }

                            {
                                attendee.category.toLowerCase() !== "children" &&
                                <div className={styles.option_item}>
                                    <label>Marital Status <span className={styles.required_input}>*</span></label> <br />
                                    <select name="maritalStatus"  id="marital" className={styles.select} value={attendee.maritalStatus} onChange={handleChange} required>
                                        <option value="">--Select your marital status--</option>
                                        <option value="Single">Single</option>
                                        <option value="Married">Married</option>
                                        {/* <option value="Engaged">Engaged</option> */}
                                    </select>        
                                </div>
                            }
                            {/* <div className={styles.form_input}>
                                <label>Birthday</label> <br />
                                <input 
                                    type="text" 
                                    name="DOB" 
                                    className={styles.input}
                                    value={attendee.DOB}
                                    onChange={handleChange}
                                    placeholder='31-01'
                                />                     
                            </div>  */}
                            <div className={styles.option_item}>
                                <label>Membership Status <span className={styles.required_input}>*</span></label> <br />
                                <select name="membershipStatus"  id="membership" className={styles.select} value={attendee.membershipStatus} onChange={handleChange} required>
                                    <option value="">--Select your membership status--</option>
                                    <option value="Member">Member</option>
                                    <option value="Guest">Guest</option>
                                </select>        
                            </div>
                            {
                                attendee.membershipStatus === 'Member' && 
                                <div className={styles.option_item}>
                                    <label>Chapter <span className={styles.required_input}>*</span></label> <br />
                                    <select name="chapter"  id="chapter" className={styles.select} value={attendee.chapter} onChange={handleChange} required>
                                        <option value="">--Select your chapter--</option>
                                        <option value="Unilag Chapter One">Unilag Chapter One</option>
                                        <option value="Unilag Chapter Two">Unilag Chapter Two</option>
                                        <option value="Medilag Chapter">Medilag Chapter</option>
                                        <option value="Yabatech Chapter">Yabatech Chapter</option>
                                        <option value="Unical Chapter">Unical Chapter</option>
                                        <option value="Other">Other</option>
                                    </select>  
                                </div>
                            }

                            {/* <div className={styles.option_item}>
                                <label>Mode of Attendance</label> <br />
                                <select name="modeOfAttendance"  id="attendance" className={styles.select} value={attendee.modeOfAttendance} onChange={handleChange} required>
                                    <option value="">--Select your attendance mode--</option>
                                    <option value="Physical">Physical</option>
                                    <option value="Virtual">Virtual</option>
                                </select>        
                            </div> */}
                            
                            {
                                attendee.membershipStatus === 'Guest' && 
                                <div className={styles.form_input}>
                                    <label>Who invited you for the easter conference? (input name) <span className={styles.required_input}>*</span></label> <br />
                                    <input 
                                        type="text" 
                                        name="invitedBy" 
                                        placeholder="e.g Joe Olorundami"
                                        className={styles.input}
                                        value={attendee.invitedBy}
                                        onChange={handleChange}
                                        required={attendee.membershipStatus === 'Guest'}
                                    />
                                </div>
                            }
                        <div className={styles.register_button}>
                                <PrimaryButton 
                                    className={styles.submit} 
                                    type="submit" 
                                    disabled={loading}
                                >
                                    {loading ? 'Loading...' : 'Submit'}
                                </PrimaryButton>
                        </div>
                        </form>
                    </div>
                </div>  
            </div>
            <RegistrationModal
                open={openRegistrationModal}
                setOpen={setOpenRegistrationModal}
                type={modalType} 
            />
        </section>
    )
}

export default RegistrationSection